import { useEffect } from "react"
import { Lang, LangEnum } from "../utils/lang"

function GlobalSignupPopUp () {
  const lang = Lang()
  useEffect(() => {
    const isJa = lang === LangEnum.JA;

    // Determine which clientToken and script source to use based on the path
    const clientToken = isJa 
      ? 'f0i8TtYsLlxG0b5FqPkBTXUIBqNZ618ZcKoeflY3IYgjTzQYU2VLP8vKWhoHHPxd'
      : 'eQ7MDaWlBlJ9Gfpgh4tydNgJZ9tVl4cR0M7ZrTpq96PNrWHNTeERHUkoCnh1cD1G';
    
    const formScriptSrc = isJa
      ? 'https://lb.benchmarkemail.com//code/lbformnew.js?mFcQnoBFKMQXxcGMbf3x0bJ25jqXIyRIG5ZnzJDOy93M99C%252F74py8jciHg%252FVbFy1'
      : 'https://lb.benchmarkemail.com//code/lbformnew.js?mFcQnoBFKMQXxcGMbf3x0cgJdt4KRNs4w36he3z6sRAJ87X6iNll88j9ybR%252Bnt%252Fk';

    const scriptId = isJa ? 'lbscript1761467' : 'lbscript1761469';
    
    // Insert the appropriate JB Tracker script
    const jbTrackerScript = document.createElement('script');
    jbTrackerScript.type = 'text/javascript';
    jbTrackerScript.innerHTML = `
      var _paq = _paq || [];
      (function() {
        if(window.apScriptInserted) return;
        _paq.push(['clientToken', '${clientToken}']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript';
        g.async=true;
        g.defer=true;
        g.src='https://prod.benchmarkemail.com/tracker.bundle.js';
        s.parentNode.insertBefore(g,s);
        window.apScriptInserted=true;
      })();
    `;
    document.body.appendChild(jbTrackerScript);

    // Insert the appropriate Benchmark Email Signup Form script
    const signupFormScript = document.createElement('script');
    signupFormScript.type = 'text/javascript';
    signupFormScript.id = scriptId;
    signupFormScript.src = formScriptSrc;
    document.body.appendChild(signupFormScript);

  }, [lang])

  return null
}

export default GlobalSignupPopUp